import { render, staticRenderFns } from "./Eligibility.vue?vue&type=template&id=56e18956&scoped=true&"
import script from "./Eligibility.vue?vue&type=script&lang=js&"
export * from "./Eligibility.vue?vue&type=script&lang=js&"
import style0 from "./Eligibility.vue?vue&type=style&index=0&id=56e18956&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e18956",
  null
  
)

export default component.exports